import { useState } from 'react'
import './MainBtn.scss'
import Modal from '../Modal/Modal'

export default function MainBtn({text}){

    const [open, setOpen] = useState(false)
    const openModal = () => {
        setOpen(!open)
    }

    return(
        <div className="MainBtn">
            <button onClick={openModal}>{text}</button>
            <Modal open={open} setOpen={openModal} />
        </div>

        
    )
}